import React from 'react';
import PropTypes from 'prop-types';
import './MyVerticallyCenteredModal.css'; // Assuming you have a CSS file for styli
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

const Modal1 = ({ show, onClose, title, imageUrl }) => {
  const naviagte = useNavigate();
  if (!show) {
    return null;
  }

  const openImageFullScreen = () => {
    naviagte("/course-33-lessons")
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <h2 className='modal-title'>{title}</h2>
        <CloseIcon className="modal-close-icon" onClick={onClose} /> {/* Cross icon */}
        <img
          src={imageUrl}
          alt={title}
          className="modal-image"
          onClick={openImageFullScreen}
        />
        <button style={{marginTop:"10px", backgroundColor:"#222232", color:"white", padding:"5px", borderRadius:"4px"}} onClick={openImageFullScreen}>Register Now</button>
      </div>
    </div>
  );
};

Modal1.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default Modal1;
